// react
import React from "react";
// icons
import { IconEdit, IconTrash } from "@tabler/icons-react";
// delete
import Delete from "../../../components/basement/admin/delete/delete.tsx";
// toast
import { NavLink } from "react-router-dom";
// loading
import Loading from "../../../components/childrens/loading/loading.tsx";
// feature
import { splitNumber } from "../../../features/splitNumber/splitNumber.tsx";
// controller
import { GetPlansController } from "../../../controllers/admin/plans/getPlans.tsx"

const PlansList = () => {
    const { data, isLoading, title, id, changeData, onSubmit } = GetPlansController()
    return (
        <>
            <section>
                {/* admin page component */}
                <div className={'admin-page-content mb-3 pt-0'}>
                    <div id={'admin-page-form'}>
                        <p className={'fw-bold box-title'}>لیست پلن ها</p>
                        <div className={'card card-body shadow border-0'}>
                            {!isLoading ? (
                                <>
                                    <div className="table-responsive">
                                        <table className="table text-center align-middle font-medium">
                                            <thead>
                                                <tr>
                                                    <th>ردیف</th>
                                                    <th>عنوان</th>
                                                    <th>توضیحات</th>
                                                    <th>قیمت</th>
                                                    <th>عملیات</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data?.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>{index}</td>
                                                        <td>{item.title}</td>
                                                        <td className="text-center" style={{ width: '300px' }}>
                                                            <p className="text-table mb-0 text-center">
                                                                {item.options}
                                                            </p>
                                                        </td>
                                                        <td>
                                                            {splitNumber(item.price)}
                                                        </td>
                                                        <td className="text-danger">
                                                            <NavLink to={`/dashboard/admin/plans/update/${item.id}`}>
                                                                <IconEdit size={16} className="text-primary me-1" onClick={() => changeData(item.id, item.title)} />
                                                            </NavLink>
                                                            <IconTrash data-bs-toggle="modal" data-bs-target="#delete-modal" onClick={() => changeData(item.id, item.title)} className="text-danger" size={16} />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <Delete id={id} title={title} function={() => onSubmit(id)} />
                                </>
                            )
                                :
                                (
                                    <>
                                        <Loading />
                                    </>
                                )
                            }

                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default PlansList;